<template>
  <div class="ready">
    <TestvIntro class="comp__TestvIntro"/>
  </div>
</template>

<script>
import TestvIntro from '@/components/TestvIntro'
export default {
  name: 'Ready',

  components: {
    TestvIntro
  },

  mounted () {
    document.documentElement.style.height = `${window.innerHeight}px`
    document.documentElement.style.overflow = 'hidden'
  },

  destroyed () {
    document.documentElement.style.height = ''
    document.documentElement.style.overflow = ''
  }
}
</script>

<style lang="stylus" scoped>
.ready {
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
}
</style>
